import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconWifiNoSignal: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconWifiNoSignal"><Path d="M10.5863 11L7.75781 8.17154L9.17203 6.75732L12.0005 9.5858L14.8289 6.75742L16.2431 8.17163L13.4147 11L16.2431 13.8284L14.8289 15.2426L12.0005 12.4142L9.17203 15.2427L7.75782 13.8285L10.5863 11Z" fill="currentColor"/><Path d="M10.7509 18.75C10.7509 19.4404 11.3106 20 12.0009 20C12.6913 20 13.2509 19.4404 13.2509 18.75C13.2509 18.0597 12.6913 17.5 12.0009 17.5C11.3106 17.5 10.7509 18.0597 10.7509 18.75Z" fill="currentColor"/></CentralIconBase>;
});

export default IconWifiNoSignal;
